/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const t = "undefined" != typeof window && null != window.customElements && void 0 !== window.customElements.polyfillWrapFlushCallback,
  e = (t, e, s = null, i = null) => {
    for (; e !== s;) {
      const s = e.nextSibling;
      t.insertBefore(e, i), e = s;
    }
  },
  s = (t, e, s = null) => {
    for (; e !== s;) {
      const s = e.nextSibling;
      t.removeChild(e), e = s;
    }
  },
  i = `{{lit-${String(Math.random()).slice(2)}}}`,
  n = `\x3c!--${i}--\x3e`,
  r = new RegExp(`${i}|${n}`);
class o {
  constructor(t, e) {
    this.parts = [], this.element = e;
    const s = [],
      n = [],
      o = document.createTreeWalker(e.content, 133, null, !1);
    let l = 0,
      c = -1,
      p = 0;
    const {
      strings: u,
      values: {
        length: m
      }
    } = t;
    for (; p < m;) {
      const t = o.nextNode();
      if (null !== t) {
        if (c++, 1 === t.nodeType) {
          if (t.hasAttributes()) {
            const e = t.attributes,
              {
                length: s
              } = e;
            let i = 0;
            for (let t = 0; t < s; t++) a(e[t].name, "$lit$") && i++;
            for (; i-- > 0;) {
              const e = u[p],
                s = d.exec(e)[2],
                i = s.toLowerCase() + "$lit$",
                n = t.getAttribute(i);
              t.removeAttribute(i);
              const o = n.split(r);
              this.parts.push({
                type: "attribute",
                index: c,
                name: s,
                strings: o
              }), p += o.length - 1;
            }
          }
          "TEMPLATE" === t.tagName && (n.push(t), o.currentNode = t.content);
        } else if (3 === t.nodeType) {
          const e = t.data;
          if (e.indexOf(i) >= 0) {
            const i = t.parentNode,
              n = e.split(r),
              o = n.length - 1;
            for (let e = 0; e < o; e++) {
              let s,
                r = n[e];
              if ("" === r) s = h();else {
                const t = d.exec(r);
                null !== t && a(t[2], "$lit$") && (r = r.slice(0, t.index) + t[1] + t[2].slice(0, -"$lit$".length) + t[3]), s = document.createTextNode(r);
              }
              i.insertBefore(s, t), this.parts.push({
                type: "node",
                index: ++c
              });
            }
            "" === n[o] ? (i.insertBefore(h(), t), s.push(t)) : t.data = n[o], p += o;
          }
        } else if (8 === t.nodeType) if (t.data === i) {
          const e = t.parentNode;
          null !== t.previousSibling && c !== l || (c++, e.insertBefore(h(), t)), l = c, this.parts.push({
            type: "node",
            index: c
          }), null === t.nextSibling ? t.data = "" : (s.push(t), c--), p++;
        } else {
          let e = -1;
          for (; -1 !== (e = t.data.indexOf(i, e + 1));) this.parts.push({
            type: "node",
            index: -1
          }), p++;
        }
      } else o.currentNode = n.pop();
    }
    for (const t of s) t.parentNode.removeChild(t);
  }
}
const a = (t, e) => {
    const s = t.length - e.length;
    return s >= 0 && t.slice(s) === e;
  },
  l = t => -1 !== t.index,
  h = () => document.createComment(""),
  d = /([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;
function c(t, e) {
  const {
      element: {
        content: s
      },
      parts: i
    } = t,
    n = document.createTreeWalker(s, 133, null, !1);
  let r = u(i),
    o = i[r],
    a = -1,
    l = 0;
  const h = [];
  let d = null;
  for (; n.nextNode();) {
    a++;
    const t = n.currentNode;
    for (t.previousSibling === d && (d = null), e.has(t) && (h.push(t), null === d && (d = t)), null !== d && l++; void 0 !== o && o.index === a;) o.index = null !== d ? -1 : o.index - l, r = u(i, r), o = i[r];
  }
  h.forEach(t => t.parentNode.removeChild(t));
}
const p = t => {
    let e = 11 === t.nodeType ? 0 : 1;
    const s = document.createTreeWalker(t, 133, null, !1);
    for (; s.nextNode();) e++;
    return e;
  },
  u = (t, e = -1) => {
    for (let s = e + 1; s < t.length; s++) {
      const e = t[s];
      if (l(e)) return s;
    }
    return -1;
  };
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const m = new WeakMap(),
  _ = t => (...e) => {
    const s = t(...e);
    return m.set(s, !0), s;
  },
  f = t => "function" == typeof t && m.has(t),
  y = {},
  g = {};
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
class S {
  constructor(t, e, s) {
    this.__parts = [], this.template = t, this.processor = e, this.options = s;
  }
  update(t) {
    let e = 0;
    for (const s of this.__parts) void 0 !== s && s.setValue(t[e]), e++;
    for (const t of this.__parts) void 0 !== t && t.commit();
  }
  _clone() {
    const e = t ? this.template.element.content.cloneNode(!0) : document.importNode(this.template.element.content, !0),
      s = [],
      i = this.template.parts,
      n = document.createTreeWalker(e, 133, null, !1);
    let r,
      o = 0,
      a = 0,
      h = n.nextNode();
    for (; o < i.length;) if (r = i[o], l(r)) {
      for (; a < r.index;) a++, "TEMPLATE" === h.nodeName && (s.push(h), n.currentNode = h.content), null === (h = n.nextNode()) && (n.currentNode = s.pop(), h = n.nextNode());
      if ("node" === r.type) {
        const t = this.processor.handleTextExpression(this.options);
        t.insertAfterNode(h.previousSibling), this.__parts.push(t);
      } else this.__parts.push(...this.processor.handleAttributeExpressions(h, r.name, r.strings, this.options));
      o++;
    } else this.__parts.push(void 0), o++;
    return t && (document.adoptNode(e), customElements.upgrade(e)), e;
  }
}
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const v = window.trustedTypes && trustedTypes.createPolicy("lit-html", {
    createHTML: t => t
  }),
  w = ` ${i} `;
class b {
  constructor(t, e, s, i) {
    this.strings = t, this.values = e, this.type = s, this.processor = i;
  }
  getHTML() {
    const t = this.strings.length - 1;
    let e = "",
      s = !1;
    for (let r = 0; r < t; r++) {
      const t = this.strings[r],
        o = t.lastIndexOf("\x3c!--");
      s = (o > -1 || s) && -1 === t.indexOf("--\x3e", o + 1);
      const a = d.exec(t);
      e += null === a ? t + (s ? w : n) : t.substr(0, a.index) + a[1] + a[2] + "$lit$" + a[3] + i;
    }
    return e += this.strings[t], e;
  }
  getTemplateElement() {
    const t = document.createElement("template");
    let e = this.getHTML();
    return void 0 !== v && (e = v.createHTML(e)), t.innerHTML = e, t;
  }
}
class x extends b {
  getHTML() {
    return `<svg>${super.getHTML()}</svg>`;
  }
  getTemplateElement() {
    const t = super.getTemplateElement(),
      s = t.content,
      i = s.firstChild;
    return s.removeChild(i), e(s, i.firstChild), t;
  }
}
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const P = t => null === t || !("object" == typeof t || "function" == typeof t),
  C = t => Array.isArray(t) || !(!t || !t[Symbol.iterator]);
class N {
  constructor(t, e, s) {
    this.dirty = !0, this.element = t, this.name = e, this.strings = s, this.parts = [];
    for (let t = 0; t < s.length - 1; t++) this.parts[t] = this._createPart();
  }
  _createPart() {
    return new T(this);
  }
  _getValue() {
    const t = this.strings,
      e = t.length - 1,
      s = this.parts;
    if (1 === e && "" === t[0] && "" === t[1]) {
      const t = s[0].value;
      if ("symbol" == typeof t) return String(t);
      if ("string" == typeof t || !C(t)) return t;
    }
    let i = "";
    for (let n = 0; n < e; n++) {
      i += t[n];
      const e = s[n];
      if (void 0 !== e) {
        const t = e.value;
        if (P(t) || !C(t)) i += "string" == typeof t ? t : String(t);else for (const e of t) i += "string" == typeof e ? e : String(e);
      }
    }
    return i += t[e], i;
  }
  commit() {
    this.dirty && (this.dirty = !1, this.element.setAttribute(this.name, this._getValue()));
  }
}
class T {
  constructor(t) {
    this.value = void 0, this.committer = t;
  }
  setValue(t) {
    t === y || P(t) && t === this.value || (this.value = t, f(t) || (this.committer.dirty = !0));
  }
  commit() {
    for (; f(this.value);) {
      const t = this.value;
      this.value = y, t(this);
    }
    this.value !== y && this.committer.commit();
  }
}
class A {
  constructor(t) {
    this.value = void 0, this.__pendingValue = void 0, this.options = t;
  }
  appendInto(t) {
    this.startNode = t.appendChild(h()), this.endNode = t.appendChild(h());
  }
  insertAfterNode(t) {
    this.startNode = t, this.endNode = t.nextSibling;
  }
  appendIntoPart(t) {
    t.__insert(this.startNode = h()), t.__insert(this.endNode = h());
  }
  insertAfterPart(t) {
    t.__insert(this.startNode = h()), this.endNode = t.endNode, t.endNode = this.startNode;
  }
  setValue(t) {
    this.__pendingValue = t;
  }
  commit() {
    if (null === this.startNode.parentNode) return;
    for (; f(this.__pendingValue);) {
      const t = this.__pendingValue;
      this.__pendingValue = y, t(this);
    }
    const t = this.__pendingValue;
    t !== y && (P(t) ? t !== this.value && this.__commitText(t) : t instanceof b ? this.__commitTemplateResult(t) : t instanceof Node ? this.__commitNode(t) : C(t) ? this.__commitIterable(t) : t === g ? (this.value = g, this.clear()) : this.__commitText(t));
  }
  __insert(t) {
    this.endNode.parentNode.insertBefore(t, this.endNode);
  }
  __commitNode(t) {
    this.value !== t && (this.clear(), this.__insert(t), this.value = t);
  }
  __commitText(t) {
    const e = this.startNode.nextSibling,
      s = "string" == typeof (t = null == t ? "" : t) ? t : String(t);
    e === this.endNode.previousSibling && 3 === e.nodeType ? e.data = s : this.__commitNode(document.createTextNode(s)), this.value = t;
  }
  __commitTemplateResult(t) {
    const e = this.options.templateFactory(t);
    if (this.value instanceof S && this.value.template === e) this.value.update(t.values);else {
      const s = new S(e, t.processor, this.options),
        i = s._clone();
      s.update(t.values), this.__commitNode(i), this.value = s;
    }
  }
  __commitIterable(t) {
    Array.isArray(this.value) || (this.value = [], this.clear());
    const e = this.value;
    let s,
      i = 0;
    for (const n of t) s = e[i], void 0 === s && (s = new A(this.options), e.push(s), 0 === i ? s.appendIntoPart(this) : s.insertAfterPart(e[i - 1])), s.setValue(n), s.commit(), i++;
    i < e.length && (e.length = i, this.clear(s && s.endNode));
  }
  clear(t = this.startNode) {
    s(this.startNode.parentNode, t.nextSibling, this.endNode);
  }
}
class E {
  constructor(t, e, s) {
    if (this.value = void 0, this.__pendingValue = void 0, 2 !== s.length || "" !== s[0] || "" !== s[1]) throw new Error("Boolean attributes can only contain a single expression");
    this.element = t, this.name = e, this.strings = s;
  }
  setValue(t) {
    this.__pendingValue = t;
  }
  commit() {
    for (; f(this.__pendingValue);) {
      const t = this.__pendingValue;
      this.__pendingValue = y, t(this);
    }
    if (this.__pendingValue === y) return;
    const t = !!this.__pendingValue;
    this.value !== t && (t ? this.element.setAttribute(this.name, "") : this.element.removeAttribute(this.name), this.value = t), this.__pendingValue = y;
  }
}
class V extends N {
  constructor(t, e, s) {
    super(t, e, s), this.single = 2 === s.length && "" === s[0] && "" === s[1];
  }
  _createPart() {
    return new U(this);
  }
  _getValue() {
    return this.single ? this.parts[0].value : super._getValue();
  }
  commit() {
    this.dirty && (this.dirty = !1, this.element[this.name] = this._getValue());
  }
}
class U extends T {}
let O = !1;
(() => {
  try {
    const t = {
      get capture() {
        return O = !0, !1;
      }
    };
    window.addEventListener("test", t, t), window.removeEventListener("test", t, t);
  } catch (t) {}
})();
class R {
  constructor(t, e, s) {
    this.value = void 0, this.__pendingValue = void 0, this.element = t, this.eventName = e, this.eventContext = s, this.__boundHandleEvent = t => this.handleEvent(t);
  }
  setValue(t) {
    this.__pendingValue = t;
  }
  commit() {
    for (; f(this.__pendingValue);) {
      const t = this.__pendingValue;
      this.__pendingValue = y, t(this);
    }
    if (this.__pendingValue === y) return;
    const t = this.__pendingValue,
      e = this.value,
      s = null == t || null != e && (t.capture !== e.capture || t.once !== e.once || t.passive !== e.passive),
      i = null != t && (null == e || s);
    s && this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options), i && (this.__options = k(t), this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options)), this.value = t, this.__pendingValue = y;
  }
  handleEvent(t) {
    "function" == typeof this.value ? this.value.call(this.eventContext || this.element, t) : this.value.handleEvent(t);
  }
}
const k = t => t && (O ? {
  capture: t.capture,
  passive: t.passive,
  once: t.once
} : t.capture)
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */;
function M(t) {
  let e = $.get(t.type);
  void 0 === e && (e = {
    stringsArray: new WeakMap(),
    keyString: new Map()
  }, $.set(t.type, e));
  let s = e.stringsArray.get(t.strings);
  if (void 0 !== s) return s;
  const n = t.strings.join(i);
  return s = e.keyString.get(n), void 0 === s && (s = new o(t, t.getTemplateElement()), e.keyString.set(n, s)), e.stringsArray.set(t.strings, s), s;
}
const $ = new Map(),
  q = new WeakMap();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
const L = new
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
class {
  handleAttributeExpressions(t, e, s, i) {
    const n = e[0];
    if ("." === n) {
      return new V(t, e.slice(1), s).parts;
    }
    if ("@" === n) return [new R(t, e.slice(1), i.eventContext)];
    if ("?" === n) return [new E(t, e.slice(1), s)];
    return new N(t, e, s).parts;
  }
  handleTextExpression(t) {
    return new A(t);
  }
}();
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
"undefined" != typeof window && (window.litHtmlVersions || (window.litHtmlVersions = [])).push("1.4.1");
const I = (t, ...e) => new b(t, e, "html", L),
  j = (t, ...e) => new x(t, e, "svg", L)
  /**
   * @license
   * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
   * This code may only be used under the BSD style license found at
   * http://polymer.github.io/LICENSE.txt
   * The complete set of authors may be found at
   * http://polymer.github.io/AUTHORS.txt
   * The complete set of contributors may be found at
   * http://polymer.github.io/CONTRIBUTORS.txt
   * Code distributed by Google as part of the polymer project is also
   * subject to an additional IP rights grant found at
   * http://polymer.github.io/PATENTS.txt
   */,
  H = (t, e) => `${t}--${e}`;
let F = !0;
void 0 === window.ShadyCSS ? F = !1 : void 0 === window.ShadyCSS.prepareTemplateDom && (console.warn("Incompatible ShadyCSS version detected. Please update to at least @webcomponents/webcomponentsjs@2.0.2 and @webcomponents/shadycss@1.3.1."), F = !1);
const z = t => e => {
    const s = H(e.type, t);
    let n = $.get(s);
    void 0 === n && (n = {
      stringsArray: new WeakMap(),
      keyString: new Map()
    }, $.set(s, n));
    let r = n.stringsArray.get(e.strings);
    if (void 0 !== r) return r;
    const a = e.strings.join(i);
    if (r = n.keyString.get(a), void 0 === r) {
      const s = e.getTemplateElement();
      F && window.ShadyCSS.prepareTemplateDom(s, t), r = new o(e, s), n.keyString.set(a, r);
    }
    return n.stringsArray.set(e.strings, r), r;
  },
  B = ["html", "svg"],
  W = new Set(),
  D = (t, e, s) => {
    W.add(t);
    const i = s ? s.element : document.createElement("template"),
      n = e.querySelectorAll("style"),
      {
        length: r
      } = n;
    if (0 === r) return void window.ShadyCSS.prepareTemplateStyles(i, t);
    const o = document.createElement("style");
    for (let t = 0; t < r; t++) {
      const e = n[t];
      e.parentNode.removeChild(e), o.textContent += e.textContent;
    }
    (t => {
      B.forEach(e => {
        const s = $.get(H(e, t));
        void 0 !== s && s.keyString.forEach(t => {
          const {
              element: {
                content: e
              }
            } = t,
            s = new Set();
          Array.from(e.querySelectorAll("style")).forEach(t => {
            s.add(t);
          }), c(t, s);
        });
      });
    })(t);
    const a = i.content;
    s ? function (t, e, s = null) {
      const {
        element: {
          content: i
        },
        parts: n
      } = t;
      if (null == s) return void i.appendChild(e);
      const r = document.createTreeWalker(i, 133, null, !1);
      let o = u(n),
        a = 0,
        l = -1;
      for (; r.nextNode();) for (l++, r.currentNode === s && (a = p(e), s.parentNode.insertBefore(e, s)); -1 !== o && n[o].index === l;) {
        if (a > 0) {
          for (; -1 !== o;) n[o].index += a, o = u(n, o);
          return;
        }
        o = u(n, o);
      }
    }(s, o, a.firstChild) : a.insertBefore(o, a.firstChild), window.ShadyCSS.prepareTemplateStyles(i, t);
    const l = a.querySelector("style");
    if (window.ShadyCSS.nativeShadow && null !== l) e.insertBefore(l.cloneNode(!0), e.firstChild);else if (s) {
      a.insertBefore(o, a.firstChild);
      const t = new Set();
      t.add(o), c(s, t);
    }
  };
window.JSCompiler_renameProperty = (t, e) => t;
const J = {
    toAttribute(t, e) {
      switch (e) {
        case Boolean:
          return t ? "" : null;
        case Object:
        case Array:
          return null == t ? t : JSON.stringify(t);
      }
      return t;
    },
    fromAttribute(t, e) {
      switch (e) {
        case Boolean:
          return null !== t;
        case Number:
          return null === t ? null : Number(t);
        case Object:
        case Array:
          return JSON.parse(t);
      }
      return t;
    }
  },
  G = (t, e) => e !== t && (e == e || t == t),
  K = {
    attribute: !0,
    type: String,
    converter: J,
    reflect: !1,
    hasChanged: G
  };
let Q = /*#__PURE__*/(() => {
  class Q extends HTMLElement {
    constructor() {
      super(), this.initialize();
    }
    static get observedAttributes() {
      this.finalize();
      const t = [];
      return this._classProperties.forEach((e, s) => {
        const i = this._attributeNameForProperty(s, e);
        void 0 !== i && (this._attributeToPropertyMap.set(i, s), t.push(i));
      }), t;
    }
    static _ensureClassProperties() {
      if (!this.hasOwnProperty(JSCompiler_renameProperty("_classProperties", this))) {
        this._classProperties = new Map();
        const t = Object.getPrototypeOf(this)._classProperties;
        void 0 !== t && t.forEach((t, e) => this._classProperties.set(e, t));
      }
    }
    static createProperty(t, e = K) {
      if (this._ensureClassProperties(), this._classProperties.set(t, e), e.noAccessor || this.prototype.hasOwnProperty(t)) return;
      const s = "symbol" == typeof t ? Symbol() : `__${t}`,
        i = this.getPropertyDescriptor(t, s, e);
      void 0 !== i && Object.defineProperty(this.prototype, t, i);
    }
    static getPropertyDescriptor(t, e, s) {
      return {
        get() {
          return this[e];
        },
        set(i) {
          const n = this[t];
          this[e] = i, this.requestUpdateInternal(t, n, s);
        },
        configurable: !0,
        enumerable: !0
      };
    }
    static getPropertyOptions(t) {
      return this._classProperties && this._classProperties.get(t) || K;
    }
    static finalize() {
      const t = Object.getPrototypeOf(this);
      if (t.hasOwnProperty("finalized") || t.finalize(), this.finalized = !0, this._ensureClassProperties(), this._attributeToPropertyMap = new Map(), this.hasOwnProperty(JSCompiler_renameProperty("properties", this))) {
        const t = this.properties,
          e = [...Object.getOwnPropertyNames(t), ...("function" == typeof Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(t) : [])];
        for (const s of e) this.createProperty(s, t[s]);
      }
    }
    static _attributeNameForProperty(t, e) {
      const s = e.attribute;
      return !1 === s ? void 0 : "string" == typeof s ? s : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    static _valueHasChanged(t, e, s = G) {
      return s(t, e);
    }
    static _propertyValueFromAttribute(t, e) {
      const s = e.type,
        i = e.converter || J,
        n = "function" == typeof i ? i : i.fromAttribute;
      return n ? n(t, s) : t;
    }
    static _propertyValueToAttribute(t, e) {
      if (void 0 === e.reflect) return;
      const s = e.type,
        i = e.converter;
      return (i && i.toAttribute || J.toAttribute)(t, s);
    }
    initialize() {
      this._updateState = 0, this._updatePromise = new Promise(t => this._enableUpdatingResolver = t), this._changedProperties = new Map(), this._saveInstanceProperties(), this.requestUpdateInternal();
    }
    _saveInstanceProperties() {
      this.constructor._classProperties.forEach((t, e) => {
        if (this.hasOwnProperty(e)) {
          const t = this[e];
          delete this[e], this._instanceProperties || (this._instanceProperties = new Map()), this._instanceProperties.set(e, t);
        }
      });
    }
    _applyInstanceProperties() {
      this._instanceProperties.forEach((t, e) => this[e] = t), this._instanceProperties = void 0;
    }
    connectedCallback() {
      this.enableUpdating();
    }
    enableUpdating() {
      void 0 !== this._enableUpdatingResolver && (this._enableUpdatingResolver(), this._enableUpdatingResolver = void 0);
    }
    disconnectedCallback() {}
    attributeChangedCallback(t, e, s) {
      e !== s && this._attributeToProperty(t, s);
    }
    _propertyToAttribute(t, e, s = K) {
      const i = this.constructor,
        n = i._attributeNameForProperty(t, s);
      if (void 0 !== n) {
        const t = i._propertyValueToAttribute(e, s);
        if (void 0 === t) return;
        this._updateState = 8 | this._updateState, null == t ? this.removeAttribute(n) : this.setAttribute(n, t), this._updateState = -9 & this._updateState;
      }
    }
    _attributeToProperty(t, e) {
      if (8 & this._updateState) return;
      const s = this.constructor,
        i = s._attributeToPropertyMap.get(t);
      if (void 0 !== i) {
        const t = s.getPropertyOptions(i);
        this._updateState = 16 | this._updateState, this[i] = s._propertyValueFromAttribute(e, t), this._updateState = -17 & this._updateState;
      }
    }
    requestUpdateInternal(t, e, s) {
      let i = !0;
      if (void 0 !== t) {
        const n = this.constructor;
        s = s || n.getPropertyOptions(t), n._valueHasChanged(this[t], e, s.hasChanged) ? (this._changedProperties.has(t) || this._changedProperties.set(t, e), !0 !== s.reflect || 16 & this._updateState || (void 0 === this._reflectingProperties && (this._reflectingProperties = new Map()), this._reflectingProperties.set(t, s))) : i = !1;
      }
      !this._hasRequestedUpdate && i && (this._updatePromise = this._enqueueUpdate());
    }
    requestUpdate(t, e) {
      return this.requestUpdateInternal(t, e), this.updateComplete;
    }
    async _enqueueUpdate() {
      this._updateState = 4 | this._updateState;
      try {
        await this._updatePromise;
      } catch (t) {}
      const t = this.performUpdate();
      return null != t && (await t), !this._hasRequestedUpdate;
    }
    get _hasRequestedUpdate() {
      return 4 & this._updateState;
    }
    get hasUpdated() {
      return 1 & this._updateState;
    }
    performUpdate() {
      if (!this._hasRequestedUpdate) return;
      this._instanceProperties && this._applyInstanceProperties();
      let t = !1;
      const e = this._changedProperties;
      try {
        t = this.shouldUpdate(e), t ? this.update(e) : this._markUpdated();
      } catch (e) {
        throw t = !1, this._markUpdated(), e;
      }
      t && (1 & this._updateState || (this._updateState = 1 | this._updateState, this.firstUpdated(e)), this.updated(e));
    }
    _markUpdated() {
      this._changedProperties = new Map(), this._updateState = -5 & this._updateState;
    }
    get updateComplete() {
      return this._getUpdateComplete();
    }
    _getUpdateComplete() {
      return this.getUpdateComplete();
    }
    getUpdateComplete() {
      return this._updatePromise;
    }
    shouldUpdate(t) {
      return !0;
    }
    update(t) {
      void 0 !== this._reflectingProperties && this._reflectingProperties.size > 0 && (this._reflectingProperties.forEach((t, e) => this._propertyToAttribute(e, this[e], t)), this._reflectingProperties = void 0), this._markUpdated();
    }
    updated(t) {}
    firstUpdated(t) {}
  }
  Q.finalized = !0;
  /**
  @license
  Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
  This code may only be used under the BSD style license found at
  http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
  http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
  found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
  part of the polymer project is also subject to an additional IP rights grant
  found at http://polymer.github.io/PATENTS.txt
  */
  return Q;
})();
const X = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype,
  Y = Symbol();
class Z {
  constructor(t, e) {
    if (e !== Y) throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t;
  }
  get styleSheet() {
    return void 0 === this._styleSheet && (X ? (this._styleSheet = new CSSStyleSheet(), this._styleSheet.replaceSync(this.cssText)) : this._styleSheet = null), this._styleSheet;
  }
  toString() {
    return this.cssText;
  }
}
const tt = t => new Z(String(t), Y),
  et = (t, ...e) => {
    const s = e.reduce((e, s, i) => e + (t => {
      if (t instanceof Z) return t.cssText;
      if ("number" == typeof t) return t;
      throw new Error(`Value passed to 'css' function must be a 'css' function result: ${t}. Use 'unsafeCSS' to pass non-literal values, but\n            take care to ensure page security.`);
    })(s) + t[i + 1], t[0]);
    return new Z(s, Y);
  };
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */
(window.litElementVersions || (window.litElementVersions = [])).push("2.5.1");
const st = {};
class it extends Q {
  static getStyles() {
    return this.styles;
  }
  static _getUniqueStyles() {
    if (this.hasOwnProperty(JSCompiler_renameProperty("_styles", this))) return;
    const t = this.getStyles();
    if (Array.isArray(t)) {
      const e = (t, s) => t.reduceRight((t, s) => Array.isArray(s) ? e(s, t) : (t.add(s), t), s),
        s = e(t, new Set()),
        i = [];
      s.forEach(t => i.unshift(t)), this._styles = i;
    } else this._styles = void 0 === t ? [] : [t];
    this._styles = this._styles.map(t => {
      if (t instanceof CSSStyleSheet && !X) {
        const e = Array.prototype.slice.call(t.cssRules).reduce((t, e) => t + e.cssText, "");
        return tt(e);
      }
      return t;
    });
  }
  initialize() {
    super.initialize(), this.constructor._getUniqueStyles(), this.renderRoot = this.createRenderRoot(), window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot && this.adoptStyles();
  }
  createRenderRoot() {
    return this.attachShadow(this.constructor.shadowRootOptions);
  }
  adoptStyles() {
    const t = this.constructor._styles;
    0 !== t.length && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow ? X ? this.renderRoot.adoptedStyleSheets = t.map(t => t instanceof CSSStyleSheet ? t : t.styleSheet) : this._needsShimAdoptedStyleSheets = !0 : window.ShadyCSS.ScopingShim.prepareAdoptedCssText(t.map(t => t.cssText), this.localName));
  }
  connectedCallback() {
    super.connectedCallback(), this.hasUpdated && void 0 !== window.ShadyCSS && window.ShadyCSS.styleElement(this);
  }
  update(t) {
    const e = this.render();
    super.update(t), e !== st && this.constructor.render(e, this.renderRoot, {
      scopeName: this.localName,
      eventContext: this
    }), this._needsShimAdoptedStyleSheets && (this._needsShimAdoptedStyleSheets = !1, this.constructor._styles.forEach(t => {
      const e = document.createElement("style");
      e.textContent = t.cssText, this.renderRoot.appendChild(e);
    }));
  }
  render() {
    return st;
  }
}
it.finalized = !0, it.render = (t, e, i) => {
  if (!i || "object" != typeof i || !i.scopeName) throw new Error("The `scopeName` option is required.");
  const n = i.scopeName,
    r = q.has(e),
    o = F && 11 === e.nodeType && !!e.host,
    a = o && !W.has(n),
    l = a ? document.createDocumentFragment() : e;
  if (((t, e, i) => {
    let n = q.get(e);
    void 0 === n && (s(e, e.firstChild), q.set(e, n = new A(Object.assign({
      templateFactory: M
    }, i))), n.appendInto(e)), n.setValue(t), n.commit();
  })(t, l, Object.assign({
    templateFactory: z(n)
  }, i)), a) {
    const t = q.get(l);
    q.delete(l);
    const i = t.value instanceof S ? t.value.template : void 0;
    D(n, l, i), s(e, e.firstChild), e.appendChild(l), q.set(e, t);
  }
  !r && o && window.ShadyCSS.styleElement(e.host);
}, it.shadowRootOptions = {
  mode: "open"
};
export { T as A, it as L, A as N, U as P, S as T, h as a, s as b, et as c, _ as d, b as e, o as f, I as h, P as i, i as m, g as n, e as r, j as s, $ as t, tt as u };
